<template>
  <div>
    <div style="margin: 0 0 20px 0">
      <el-input v-model="words" placeholder="姓名搜索" class="input-with-select" style="width: 240px">
        <el-input></el-input>
        <el-button type="primary" slot="append" icon="el-icon-search" @click="search">搜索</el-button>
      </el-input>
    </div>

    <div>
      <el-table ref="table" border :data="tableData" stripe style="width: 100%">
        <el-table-column type="selection" width="50" align="center"></el-table-column>
        <el-table-column prop="userId" label="主键" width="80" align="center"> </el-table-column>
        <el-table-column prop="loginName" label="账号"> </el-table-column>
        <el-table-column prop="userName" label="姓名"></el-table-column>
      </el-table>
    </div>
    <div style="margin: 20px 0 0 -5px">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="pagesize" :current-page="currentPage" @current-change="pageChange"> </el-pagination>
    </div>
    <div style="margin: 20px 0; text-align: right">
      <el-button type="default" @click="clickClose">关闭</el-button>
      <el-button type="primary" @click="clickYes">确定</el-button>
    </div>
  </div>
</template>

<script>
import usersApi from "@/api/users"
export default {
  name: "SearchUser",
  props: {
    single: {
      type: Boolean,
      default: true,
    },
    closeFun: {
      type: Function,
    },
    yesFun: {
      type: Function,
    },
  },
  data() {
    return {
      words: "",
      total: 0,
      pagesize: 10,
      currentPage: 0,
      tableData: [],
    }
  },

  mounted() {
    this.loadData()
  },

  methods: {
    search() {
      this.loadData()
    },
    loadData() {
      usersApi.find(this.words, "user_id", "ASC", this.currentPage, this.pagesize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      })
    },
    pageChange(curPage) {
      this.currentPage = curPage
      this.loadData()
    },

    clickClose() {
      this.closeFun()
    },

    clickYes() {
      let rows = this.$refs.table.selection
      if (rows <= 0) {
        this.$alert("请选择行记录", "警告", {
          confirmButtonText: "确定",
        })
      } else {
        if (this.single && rows.length > 1) {
          this.$alert("只能选择一行记录", "警告", {
            confirmButtonText: "确定",
          })
          return false
        }
        this.yesFun(rows)
      }
    },
  },
}
</script>
